export default __webpack_public_path__ + "static/impressit-meta-image-4960d4e6d9e29f7810c04f504c2d2f1a.jpg";